import Type1 from "./packingGroupType1";

export default Type1;
